/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlideshowClassic = {
	init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsSlideshowClassic = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');

    const $slideshowClassic = $slideshowClassicEl.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: this.image_slideshow_speed * 1000,
      arrowShape: arrowShape
    });

    // Resize flickity when the slider is settled
    $slideshowClassicEl.on( 'settle.flickity', function() {
      $slideshowClassicEl.flickity('resize');
    })

  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

  },
	unload: function($section) {

	}
}

/******/ })()
;
/**
 * Flickity Navigation Button ARIA Labels
 * Updates aria-label attributes for better accessibility
 */

(function() {
  'use strict';

  /**
   * Update ARIA labels for Flickity navigation buttons
   */
  function updateFlickityAriaLabels() {
    // Find all previous buttons
    const prevButtons = document.querySelectorAll('.flickity-button.flickity-prev-next-button.previous');
    prevButtons.forEach(button => {
      button.setAttribute('aria-label', 'Previous slide');
    });

    // Find all next buttons
    const nextButtons = document.querySelectorAll('.flickity-button.flickity-prev-next-button.next');
    nextButtons.forEach(button => {
      button.setAttribute('aria-label', 'Next slide');
    });

    console.log(`Updated ${prevButtons.length} previous buttons and ${nextButtons.length} next buttons`);
  }

  /**
   * Enhanced version with current slide context
   */
  function updateFlickityAriaLabelsEnhanced() {
    // Find all Flickity carousels
    const flickityCarousels = document.querySelectorAll('.flickity-enabled');

    flickityCarousels.forEach(carousel => {
      // Get Flickity instance if available
      let flkty = null;
      if (typeof Flickity !== 'undefined') {
        try {
          flkty = Flickity.data(carousel);
        } catch (e) {
          // Flickity instance not found, continue with basic update
        }
      }

      // Find buttons within this carousel
      const prevButton = carousel.querySelector('.flickity-button.previous');
      const nextButton = carousel.querySelector('.flickity-button.next');

      if (prevButton && nextButton && flkty) {
        // Enhanced labels with context
        const currentIndex = flkty.selectedIndex + 1;
        const totalSlides = flkty.slides.length;

        prevButton.setAttribute('aria-label', `Previous slide (currently on slide ${currentIndex} of ${totalSlides})`);
        nextButton.setAttribute('aria-label', `Next slide (currently on slide ${currentIndex} of ${totalSlides})`);

        // Update on slide change
        flkty.on('change', function(index) {
          const slideNumber = index + 1;
          prevButton.setAttribute('aria-label', `Previous slide (currently on slide ${slideNumber} of ${totalSlides})`);
          nextButton.setAttribute('aria-label', `Next slide (currently on slide ${slideNumber} of ${totalSlides})`);
        });

        // Disable buttons at start/end if not looping
        if (!flkty.options.wrapAround) {
          flkty.on('select', function() {
            // Disable previous button on first slide
            if (flkty.selectedIndex === 0) {
              prevButton.setAttribute('disabled', '');
              prevButton.setAttribute('aria-disabled', 'true');
            } else {
              prevButton.removeAttribute('disabled');
              prevButton.setAttribute('aria-disabled', 'false');
            }

            // Disable next button on last slide
            if (flkty.selectedIndex === flkty.slides.length - 1) {
              nextButton.setAttribute('disabled', '');
              nextButton.setAttribute('aria-disabled', 'true');
            } else {
              nextButton.removeAttribute('disabled');
              nextButton.setAttribute('aria-disabled', 'false');
            }
          });
        }
      } else if (prevButton && nextButton) {
        // Fallback to simple labels if no Flickity instance
        prevButton.setAttribute('aria-label', 'Previous slide');
        nextButton.setAttribute('aria-label', 'Next slide');
      }
    });
  }

  /**
   * Observer to watch for dynamically added buttons
   */
  function observeFlickityButtons() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // Element node
            // Check if the added node is a Flickity button
            if (node.matches && node.matches('.flickity-button')) {
              updateFlickityAriaLabelsEnhanced();
            }
            // Check if added node contains Flickity buttons
            if (node.querySelectorAll) {
              const buttons = node.querySelectorAll('.flickity-button');
              if (buttons.length > 0) {
                updateFlickityAriaLabelsEnhanced();
              }
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return observer;
  }

  /**
   * Initialize the script
   */
  function init() {
    // Initial update
    updateFlickityAriaLabelsEnhanced();

    // Watch for dynamic content
    observeFlickityButtons();

    console.log('Flickity ARIA labels initialized');
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run after page load (for lazy-loaded carousels)
  window.addEventListener('load', () => {
    setTimeout(updateFlickityAriaLabelsEnhanced, 500);
  });

  // Expose functions globally for manual triggering
  window.updateFlickityAriaLabels = updateFlickityAriaLabelsEnhanced;

})();